
if not App.angularApp?
    return

###
 * natSort filter
 *
 * Replacement for the native orderBy filter. Uses strnatcasecmp (from php.js)
 * when possible for comparing values. Should accept the exact same parameters
 * as the native orderBy filter.
###
App.angularApp.filter 'natSort', ['$parse', ($parse) =>

    string_types = [
        'string'
        'number'
    ]

    # props can be a single property/expression or an array of properties/expression
    # reverse indicates whether to reverse the sort order
    return (input, props, reverse = false) =>
        # TODO: cache the result to improve performance when called on the same
        # array multiple times. (Currently gets kinda slow when used on an
        # array containing a few hundred items.) Caching should be state-
        # specific, and should be cleared when the state is destroyed.

        # create a copy of the array
        if input and input.length
            arr = $.merge [], input
        else
            return []

        # if only a single predicate is given, wrap it in an array
        if props not instanceof Array
            props = [props]

        # this is our value comparator function
        compare = (a, b) =>
            # if one value is undefined sort it below
            if not a?
                return -1
            if not b?
                return 1
            # use strnatcasecmp if possible
            if typeof a in string_types and typeof b in string_types
                return strnatcasecmp(a, b)

            # otherwise use a simple comparison
            return 1 if a > b
            return -1 if a < b
            return 0

        return arr.sort (a, b) ->
            for prop in props
                # console.log prop
                # console.log typeof prop
                # TODO: there may be a way to do this that evaulates properties
                # and expressions all fancy and angular-like instead

                # special handling for using '-' to sort in descending order
                desc = false
                if typeof prop is 'string' and prop[0] is '-'
                    desc = true
                    # remove the '-' from the property name
                    prop = prop.slice(1)

                # use $parse to evaulate values, then call compare()
                cmp = compare $parse(prop)(a), $parse(prop)(b)

                # if it's 0 the values are the same, look at the next property
                if cmp is 0
                    continue

                # flip the comparator value for descending order
                if desc
                    cmp = -cmp

                # flip the comparator value for reverse sort order
                # Note: value is flipped twice if both reverse and '-' are used
                if reverse
                    cmp = -cmp

                return cmp

            # if we get here, all sort properties are equal
            return 0
]
